(function () {
  var STACK_SELECTOR = '.ck-rating-bar__outer, .announcement-bar__outer, .header__outer-wrapper';
  var HIDDEN_CLASS = 'ck-sticky-header--hidden';
  var ANIMATED_CLASS = 'ck-sticky-header--animated';
  var DESKTOP_QUERY = window.matchMedia('(min-width: 60em)');
  var THRESHOLD = 5;
  var lastY = 0;
  var ticking = false;
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(updateOffsets) : null;

  function getStack() {
    return Array.prototype.slice.call(document.querySelectorAll(STACK_SELECTOR));
  }

  function getMode() {
    var header = document.querySelector('[data-ck-sticky-desktop]');
    if (!header) return null;

    return DESKTOP_QUERY.matches
      ? header.getAttribute('data-ck-sticky-desktop')
      : header.getAttribute('data-ck-sticky-mobile');
  }

  function updateOffsets() {
    var top = 0;

    getStack().forEach(function (element) {
      element.style.setProperty('--ck-sticky-top', top + 'px');
      element.style.setProperty('--ck-sticky-height', element.offsetHeight + 'px');
      top += element.offsetHeight;
    });
  }

  function setHidden(stack, hidden) {
    stack.forEach(function (element) {
      element.classList.toggle(HIDDEN_CLASS, hidden);
    });
  }

  function update() {
    ticking = false;

    var stack = getStack();
    var mode = getMode();
    if (!stack.length || !mode) return;

    var y = Math.max(window.pageYOffset, 0);

    if (mode !== 'on_scroll_up') {
      setHidden(stack, false);
      lastY = y;
      return;
    }

    var delta = y - lastY;
    if (Math.abs(delta) < THRESHOLD) return;

    var stackHeight = stack.reduce(function (sum, element) {
      return sum + element.offsetHeight;
    }, 0);
    var hasFocus = stack.some(function (element) {
      return element.contains(document.activeElement);
    });

    stack.forEach(function (element) {
      element.classList.add(ANIMATED_CLASS);
    });

    if (delta > 0 && y > stackHeight && !hasFocus) {
      setHidden(stack, true);
    } else if (delta < 0 || y <= stackHeight) {
      setHidden(stack, false);
    }

    lastY = y;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function reset() {
    var stack = getStack();

    if (resizeObserver) {
      stack.forEach(function (element) {
        resizeObserver.observe(element);
      });
    }

    updateOffsets();
    lastY = Math.max(window.pageYOffset, 0);
    update();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', reset);
  document.addEventListener('shopify:section:load', reset);
  document.addEventListener('shopify:section:unload', reset);
  reset();
})();
